import React, { useState } from "react";
import Button from "components/common/Button";
import * as styles from "../styles";

type BatchUrlFormProps = {
  size?: "large" | "compact";
  onSubmit: (url: string) => Promise<void>;
  buttonText: string;
};

const BatchUrlForm: React.FC<BatchUrlFormProps> = ({
  size = "large",
  onSubmit,
  buttonText,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async () => {
    const raw = inputValue.trim();
    if (!raw || isSubmitting) return;

    setIsSubmitting(true);
    await onSubmit(raw);
    setIsSubmitting(false);
  };

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = async e => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    await submit();
  };

  return (
    <styles.TextInputContainer $inputSize={size}>
      <styles.TextInput
        $inputSize={size}
        type="text"
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="example.com"
      />
      <styles.SearchOptions>
        <Button
          type="button"
          size="sm"
          disabled={!inputValue.trim() || isSubmitting}
          onClick={submit}
        >
          {buttonText}
        </Button>
      </styles.SearchOptions>
    </styles.TextInputContainer>
  );
};

export default BatchUrlForm;
